module.exports = __webpack_public_path__ + "img/kagami-long.5c635e43.png";